/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraMisConfigurationsTrendListRequestFilters extends models.InfraIssuesTimeRangeFilter {
    getFixupPrototypeFunction() { return InfraMisConfigurationsTrendListRequestFilters.fixupPrototype; }

    static newInstance(model: Partial<InfraMisConfigurationsTrendListRequestFilters>): InfraMisConfigurationsTrendListRequestFilters {
        let obj = Object.assign(new InfraMisConfigurationsTrendListRequestFilters(), model);
        InfraMisConfigurationsTrendListRequestFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraMisConfigurationsTrendListRequestFilters>): InfraMisConfigurationsTrendListRequestFilters {
        if (!model) return null;
        return InfraMisConfigurationsTrendListRequestFilters.newInstance(<InfraMisConfigurationsTrendListRequestFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraMisConfigurationsTrendListRequestFilters) {
        if (!obj) return;

        models.InfraMisConfigurationsTrendListRequestFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraMisConfigurationsTrendListRequestFilters): boolean {
        if (models.InfraIssuesTimeRangeFilter.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, InfraMisConfigurationsTrendListRequestFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.filters) {
            models.SecurityInfraIssuesDashboardFilters.fixupPrototype(this.filters);
        }
    }

    /**
     * Filters applied to the issues trend data.
     */
    filters: models.SecurityInfraIssuesDashboardFilters;

    /**
     * Search text to filter the infrastructure misconfigurations based on resource name, resource id, service name, etc.
     */
    search: string;

}
